import React from "react"
import { Link } from "gatsby"
import { Nav } from "react-bootstrap"
import HorizontalMenu from "./horizontalmenu"
import "./menu.css"

export default () => (
  <div className="navigation">
    <HorizontalMenu />
  </div>
)
